/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Replaces "Chatwoot" in text with the installation name from global config
   * or with a provided replacement name.
   * @param {string} text - The text to process
   * @param {string} replacementName - Optional replacement for "Chatwoot"
   * @returns {string} - Text with "Chatwoot" replaced by installation name
   */
  const replaceInstallationName = (text, replacementName) => {
    if (!text) return text;

    const resolvedReplacementName =
      replacementName || globalConfig.value?.installationName;
    if (!resolvedReplacementName) return text;

    return text.replace(/Chatwoot/g, resolvedReplacementName);
  };

  return {
    replaceInstallationName,
  };
}
